import * as React from 'react';

import Filter16 from './Filter16';

export const filter16 = () => <Filter16 />;

export default {
    title: 'Icon|Fill|Filter16',
    component: Filter16,
    parameters: {
        notes: "`import Filter16 from 'box-ui-elements/es/icon/fill/Filter16';`",
    },
};
